export default __webpack_public_path__ + "static/Humour-18130ad70ad058800a755b481fce2691.jpg";